import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=b0afe558&scoped=true&"
import script from "./collections.vue?vue&type=script&lang=js&"
export * from "./collections.vue?vue&type=script&lang=js&"
import style0 from "./collections.vue?vue&type=style&index=0&id=b0afe558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0afe558",
  null
  
)

export default component.exports